import { AfterViewInit, Component, TemplateRef, ViewChild, inject, signal, OnInit } from '@angular/core';
import { UpdatePageTitle } from '../../../../store/app/app.actions';
import { Store } from '@ngxs/store';
import { CardTopupsBalanceWidget } from '../_components/card-topups-balance-widget/card-topups-balance-widget';
import { AppTableComponent } from '../../../../shared/components/table/app-table.component';
import { CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { EmptyIndicatorPipe } from '../../../../shared/pipes/empty-indicator.pipe';
import { RecurringFilterComponent } from '../recurring-topups/recurring-filter/recurring-filter.component';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import { HttpParams } from '@angular/common/http';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';
import { Observable } from 'rxjs';
import { PaginatedResults } from '@bo/ng-api';
import { CardFundsHistory, CardFundType, CardType } from '../../../../_interfaces/cards.interface';
import { CardsApiService } from '../../../../_services/cards-service/cards-api/cards-api.service';
import { updateParamsObject } from '../../../../shared/utils/filter-utils';
import { immediateTopupTableColumns } from '../../../../_services/topup-service/card-topups-utils';
import { ImmediateTopUpSearchOptions } from '../../../../shared/components/forms/search-field/search-utils';
import { TableHeaderTemplateComponent } from '../../../../shared/components/table-header-template/table-header-template.component';
import { CardNumberDisplayComponent } from '../../../../shared/components/card-number-display/card-number-display.component';

@Component({
  selector: 'app-immediate-top-ups',
  imports: [
    CardTopupsBalanceWidget,
    AppTableComponent,
    CurrencyPipe,
    EmptyIndicatorPipe,
    RecurringFilterComponent,
    RouterOutlet,
    DatePipe,
    NgClass,
    TableHeaderTemplateComponent,
    CardNumberDisplayComponent,
  ],
  templateUrl: './immediate-topups.component.html',
})
export class ImmediateTopupsComponent implements OnInit, AfterViewInit {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly cardsApiService = inject(CardsApiService);
  readonly offcanvasService = inject(OffcanvasService);

  columns: Array<TableColumn> = [];
  queryParams = new HttpParams();
  protected readonly immediateTopUpSearchOptions = ImmediateTopUpSearchOptions;
  protected readonly CardType = CardType;
  private readonly columnsInitialized = signal(false);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // TODO: TemplateRef<any> can be fixed by refactoring the @bo/ng-datatable library.
  @ViewChild('cardDateCell', { static: false }) cardDateCell!: TemplateRef<any>;
  @ViewChild('cardNumberCell', { static: false }) cardNumberCell!: TemplateRef<any>;
  @ViewChild('cardNameCell', { static: false }) cardNameCell!: TemplateRef<any>;
  @ViewChild('cardHolderCell', { static: false }) cardHolderCell!: TemplateRef<any>;
  @ViewChild('transferredByCell', { static: false }) transferredByCell!: TemplateRef<any>;
  @ViewChild('amountCell', { static: false }) amountCell!: TemplateRef<any>;
  /* eslint-enable @typescript-eslint/no-explicit-any */

  constructor() {
    this.store.dispatch(new UpdatePageTitle('Immediate Top-ups'));
  }

  ngOnInit() {
    // Initialise columns early to prevent expression changed error
    this.columns = immediateTopupTableColumns;
  }

  ngAfterViewInit(): void {
    this.setupColumns();
  }

  private setupColumns(): void {
    if (this.columnsInitialized()) return;

    // Set templates on columns
    for (const column of this.columns) {
      if (column.prop === 'created') column.cellTemplate = this.cardDateCell;
      if (column.prop === 'card.masked_number') column.cellTemplate = this.cardNumberCell;
      if (column.prop === 'card.name') column.cellTemplate = this.cardNameCell;
      if (column.prop === 'card.holder.first_name') column.cellTemplate = this.cardHolderCell;
      if (column.prop === 'creator.first_name') column.cellTemplate = this.transferredByCell;
      if (column.prop === 'amount') column.cellTemplate = this.amountCell;
    }

    // Reassign array to trigger change detection in the table
    this.columns = [...this.columns];
    this.columnsInitialized.set(true);
  }
  getData(params: HttpParams): Observable<PaginatedResults<Array<CardFundsHistory>>> {
    return this.cardsApiService.getCardFundsTransactionHistory(params);
  }

  update(params: HttpParams) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updateParamsObject(params),
    });
  }

  protected absoluteValue(value: string): number {
    return Math.abs(Number.parseFloat(value));
  }

  onCreate() {
    this.offcanvasService.offCanvasNavigate(`/card-topups/immediate/add`);
  }

  protected readonly CardFundType = CardFundType;
}
